import { ChangeDetectionStrategy, Component, inject, computed } from '@angular/core';
import { MatDialogRef, MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import * as Models from '@shared/models';

const DEFAULT_PARAMS: Models.IConfirmModalParams = {
  headerIconClass: 'fa-warning',
  headerText: 'Confirm',
  bodyText: 'Are you sure?',
  okText: 'OK',
  cancelText: 'Cancel',
  allowHtml: false,
  infoOnly: false,
};

@Component({
  selector: 'app-generic-confirm-modal',
  templateUrl: './genericModal.component.html',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenericConfirmModalComponent {
  private readonly dialogRef = inject(MatDialogRef<GenericConfirmModalComponent>);
  private readonly data = inject<Models.IConfirmModalParams>(MAT_DIALOG_DATA, { optional: true });

  // Computed params merging defaults with injected data (signal prefix for template reads)
  readonly signalModalParams = computed<Models.IConfirmModalParams>(() => ({
    headerIconClass: this.data?.headerIconClass ?? DEFAULT_PARAMS.headerIconClass,
    headerText: this.data?.headerText ?? DEFAULT_PARAMS.headerText,
    bodyText: this.data?.bodyText ?? DEFAULT_PARAMS.bodyText,
    okText: this.data?.okText ?? DEFAULT_PARAMS.okText,
    cancelText: this.data?.cancelText ?? DEFAULT_PARAMS.cancelText,
    allowHtml: this.data?.allowHtml ?? DEFAULT_PARAMS.allowHtml,
    infoOnly: this.data?.infoOnly ?? DEFAULT_PARAMS.infoOnly,
    modalSize: this.data?.modalSize,
  }));
  readonly showCancelButton = computed(() => {
    const params = this.signalModalParams();
    return !params.infoOnly && (params.cancelText?.trim().length ?? 0) > 0;
  });

  cancel(): void {
    this.dialogRef.close(false);
  }

  ok(): void {
    this.dialogRef.close(true);
  }
}
